"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponValidation = exports.CouponValueUnit = exports.CouponCategory = exports.CouponType = void 0;
var CouponType;
(function (CouponType) {
    CouponType[CouponType["SingleUse"] = 1] = "SingleUse";
    CouponType[CouponType["MultiUse"] = 2] = "MultiUse";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
var CouponCategory;
(function (CouponCategory) {
    CouponCategory[CouponCategory["Promo"] = 1] = "Promo";
    CouponCategory[CouponCategory["Referral"] = 2] = "Referral";
    CouponCategory[CouponCategory["FixedBid"] = 3] = "FixedBid";
    CouponCategory[CouponCategory["Warranty"] = 4] = "Warranty";
    CouponCategory[CouponCategory["CustomerSatisfaction"] = 5] = "CustomerSatisfaction";
    CouponCategory[CouponCategory["PriceAdjustment"] = 6] = "PriceAdjustment";
})(CouponCategory = exports.CouponCategory || (exports.CouponCategory = {}));
var CouponValueUnit;
(function (CouponValueUnit) {
    CouponValueUnit[CouponValueUnit["Currency"] = 1] = "Currency";
    CouponValueUnit[CouponValueUnit["Percent"] = 2] = "Percent";
})(CouponValueUnit = exports.CouponValueUnit || (exports.CouponValueUnit = {}));
var CouponValidation;
(function (CouponValidation) {
    CouponValidation[CouponValidation["Valid"] = 1] = "Valid";
    CouponValidation[CouponValidation["Invalid"] = 2] = "Invalid";
    CouponValidation[CouponValidation["Inactive"] = 3] = "Inactive";
    CouponValidation[CouponValidation["Expired"] = 4] = "Expired";
    CouponValidation[CouponValidation["Limit"] = 5] = "Limit";
    CouponValidation[CouponValidation["UserLimit"] = 6] = "UserLimit";
})(CouponValidation = exports.CouponValidation || (exports.CouponValidation = {}));
